import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import LandingPage from './pages/LandingPage'
import Dashboard from './pages/Dashboard'
import Editor from './pages/Editor'
import AuthPage from './pages/AuthPage'
import { useAuthStore } from './store/authStore'

function App() {
  const { initialize, loading } = useAuthStore()

  useEffect(() => {
    initialize()
  }, [initialize])

  if (loading) {
    return (
      <div className="min-h-screen bg-midnight-950 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-2 border-ember-400 border-t-transparent rounded-full animate-spin" />
          <p className="text-midnight-400 font-body">Loading Lumina...</p>
        </div>
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/editor/:projectId?" element={<Editor />} />
    </Routes>
  )
}

export default App

